<template>
    <ContainerContent
        class="mb-8"
        max-class="max-w-sm-floor"
        outer-container
    >
        <v-row>
            <v-col>
                <h1 class="page-title">Forgot Password</h1>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <ForgotPassword></ForgotPassword>
            </v-col>
        </v-row>
    </ContainerContent>
</template>

<script lang="ts" setup>
    import ForgotPassword from '~/components/user/ForgotPassword/ForgotPassword.vue';
    import ContainerContent from '~/components/ContainerContent/ContainerContent.vue';

    definePageMeta({
        scrollToTop: true
    });

    const $config = useRuntimeConfig();
    const brandTitle = $config.public.brand.title;

    useHead({
        title: `Forgot Password | ${brandTitle}`,
        meta: [
            {
                name: 'description',
                content: 'Forgot Password'
            }
        ]
    });
</script>
